import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { SponsorsService } from 'src/app/services/sponsors.service';
import { environment } from 'src/environments/environment';
import { CategoryService } from '../../../services/category.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
  providers: [MessageService]
})

export class AddSponsorsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  pageTitle: string;
  statuses: any = [];
  sponsorsForm: FormGroup;
  sponsorsStatus: boolean = true;
  notproduct: boolean = false;
  showUploadedpic: boolean = false;
  uploadedFiles: any[] = [];
  sponsorsImage: any[] = [];
  submitted: boolean = false;
  minYear = environment.minYear;
  yearRange: string;
  categorylist: any = [];
  errorMessage = '';
  id:any;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropDialog: boolean = false;
  selectedFile: File | null = null;
  imageSize = 2000000;
  croppedImageMaxSize = 2000000;
  croppedImageSize = 0;
  croppedImageError: string | null = null;
  scale = 1;
  transform: ImageTransform = {};
  cropApplied = false;


  constructor(private formBuilder: FormBuilder, private router: Router, private sponsorsService: SponsorsService, 
    private categoryService: CategoryService, private messageService: MessageService) { }

  ngOnInit(): void {
    this.yearRange = this.minYear + ":2030";
    this.pageTitle = 'Add Sponsor';
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];

    this.sponsorsForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      category: ['', [Validators.required]],      
      brandName: ['', Validators.required],
      status: [true, Validators.required],     
      link: [''],     
    });
    this.getSubCategory();
  }

  getSubCategory(){ 
      const query = `?filterByDisable=false&getSubcategory=true&pageSize=10&pageNumber=1&filterByParentCategory=Sponsors`;
            this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {                        
              this.categorylist = data.data.items;                   
      },
      err => {
          this.errorMessage = err.error.message;
      }
    );
  }


  get f() {
    return this.sponsorsForm.controls;
  }

  onStatusSelect(event) {
    if (event) {
      this.sponsorsStatus = event.value;
    }
  }

  onFileSelect(event: any) {
    const file = event.files[0];
    if (!file) return;
    if (file.size > this.imageSize) {
      this.rejectOversizedImage();
      return;
    }

    this.cropApplied = false;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = file;
    this.resetZoom();
    const fileEvent: any = {
      target: {
        files: [file]
      }
    };
    this.imageChangedEvent = fileEvent;
    this.cropDialog = true;
  }

  zoomIn() {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomOut() {
    if (this.scale > 0.2) {
      this.scale -= 0.1;
      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    }
  }

  resetZoom() {
    this.scale = 1;
    this.transform = {
      ...this.transform,
      scale: 1
    };
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
    this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
      ? 'Cropped image size must be less than 2 MB.'
      : null;
  }
      
  getBase64SizeBytes(base64: string): number {
    if (!base64) return 0;
    return Math.round(
      (base64.length * (3 / 4)) -
      (base64.split(',')[0].length + 1)
    );
  }

  applyCrop() {
    if (this.croppedImageError) return;
    const file = this.base64ToFile(
      this.croppedImage,
      this.selectedFile?.name || 'image.png'
    );
    this.fileUpload.clear();
    if (file.size > this.croppedImageMaxSize) {
        this.croppedImageError = 'Cropped image size must be less than 2 MB.';
        return;
    }
    const event = {
      files: [file]
    };
    this.picUploader(event);
    this.fileUpload.files = [file];
    this.cropApplied = true;
    this.cropDialog = false;
  }

  onCropCancel() {
    this.cropApplied = false;
    this.cropDialog = false;
    this.imageChangedEvent = null;
    this.croppedImage = null;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = null;
    this.resetZoom();
    if (this.fileUpload) {
      this.fileUpload.clear();
    }
    this.uploadedFiles = [];
    this.sponsorsImage = [];
  }

  onDialogHide() {
    if (!this.cropApplied) {
      this.onCropCancel();
    } else {
      this.imageChangedEvent = null;
      this.croppedImage = null;
      this.croppedImageError = null;
      this.croppedImageSize = 0;
      this.selectedFile = null;
      this.resetZoom();
    }
  }
      
  rejectOversizedImage() {
    this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image smaller than 2 MB', life: 6000 });
    this.onCropCancel();
  }

  base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  picUploader(event: any) {
  const files: File[] = event?.files || event;
  if (!files || files.length === 0) return;
    if(this.sponsorsImage.length !== 0) {
      this.sponsorsImage = [];
    }
    this.notproduct = false;
    let index = 0;
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // called once readAsDataURL is completed
        if (reader.result != null) {
          this.sponsorsImage.push({ 'file': reader.result });
          index++;
        }
      }
    }
  }

  removeFile(event) {
    this.uploadedFiles = [];
    this.sponsorsImage = [];
  }

  onSubmit() { 
    this.submitted = true;
    let addSponsorsData = {};
    if (this.sponsorsImage.length === 0) {
      this.notproduct = true;
      return;
    } else {
      this.notproduct = false;
    }

    if (this.sponsorsForm.invalid) {
      return;
    }

    addSponsorsData['title'] = this.sponsorsForm.value.title;
    addSponsorsData['category'] = this.sponsorsForm.value.category.id;
    addSponsorsData['brandName'] = this.sponsorsForm.value.brandName;
    addSponsorsData['status'] = this.sponsorsForm.value.status;
    addSponsorsData['link'] = this.sponsorsForm.value.link;
   // addSponsorsData['date'] = moment(this.sponsorsForm.value.date, "DD-MM-YYYY").format("YYYY-MM-DD");
    addSponsorsData['photo'] = this.sponsorsImage[0].file;

    addSponsorsData = JSON.stringify(addSponsorsData, null, 4);
    this.sponsorsService.addSponsors(addSponsorsData).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      //console.log(data,'DFF');
      this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Sponsor Added Successfully', life: 6000 });
      setTimeout(() => {
        this.router.navigate(['/manage/media/sponsors']);
      }, 2000);
    }, (error) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.message, life: 6000 });
    })
  }

  backLink() {
    this.router.navigate(['/manage/media/sponsors']);
  }
  

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
